import React, { useState, useEffect } from 'react';
import { getCurrentUser } from '../lib/auth';
import DashboardCatalogue from '../components/DashboardCatalogue';

const AdminCatalogue = () => {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
      setLoading(false);
    };
    loadUser();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user || user.role !== 'admin') {
    return (
      <div className="text-center py-10">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Accès restreint</h3>
        <p className="text-gray-600">
          Vous n'avez pas les droits nécessaires pour accéder à cette page.
        </p>
      </div>
    );
  }

  return <DashboardCatalogue user={user} />;
};

export default AdminCatalogue;